import { func, object } from 'prop-types';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import {
  getReactSelectValue,
  ReactSelectInput,
} from '@hivebrite/design-system/Inputs';

import InputTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/InputTitle';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';
import type { SectionItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/sectionItemAttributes';

const options = [
  {
    label: __('Stack columns'),
    value: 'stack',
  },
  {
    label: __('Side by side'),
    value: 'group',
  },
];

const MobileDisplay = ({
  defaultAttributes,
  item,
  onChange,
}: ComponentSettingsTab<SectionItemAttributes>) => {
  const [value, setValue] = useState<string | undefined>(
    item?.attributes?.mobileDisplay || defaultAttributes?.mobileDisplay,
  );

  useEffect(() => {
    setValue(item?.attributes?.mobileDisplay);
  }, [item?.attributes?.mobileDisplay]);

  const handleChange = (e) => {
    setValue(e.value);

    onChange({
      id: item.id,
      settingKey: 'attributes.mobileDisplay',
      value: e.value,
    });
  };

  const valueSelected = getReactSelectValue(options, value);

  return (
    <MobileDisplayWrapper>
      <InputTitle id="settingsMobileDisplay" label={__('Mobile display')} />
      <ReactSelectInput
        ariaLabel={__('Mobile display')}
        id="settingsMobileDisplay"
        name="settingsMobileDisplay"
        onChange={handleChange}
        options={options}
        placeholder={valueSelected?.label}
        value={valueSelected}
        variant="small"
        width={155}
      />
    </MobileDisplayWrapper>
  );
};

export default MobileDisplay;

const MobileDisplayWrapper = styled(Box).attrs(() => ({
  alignItems: 'center',
  justifyContent: 'space-between',
  mb: 4,
}))``;

MobileDisplay.defaultProps = {
  title: __('Font size'),
};

MobileDisplay.propTypes = {
  defaultAttributes: object,
  item: object.isRequired,
  onChange: func.isRequired,
};
